import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=47cc536e&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"
import style0 from "./switch.vue?vue&type=style&index=0&id=47cc536e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc536e",
  null
  
)

export default component.exports